(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["custom-my-faq"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', function() {
  const accordions = document.querySelectorAll('details.accordion-row');
  accordions.forEach(function(acc) {
    const plusIcon = acc.querySelector('.icon-plus');

    plusIcon.addEventListener('click', function(e) {
      e.preventDefault();
      acc.open = !acc.open;
    });
  });
});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["single-akkordeon"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', function() {
  const accordions = document.querySelectorAll('details.accordion-row');
  accordions.forEach(function(acc) {
    const plusIcon = acc.querySelector('.icon-plus');

    plusIcon.addEventListener('click', function(e) {
      e.preventDefault();
      acc.open = !acc.open;
    });
  });
});
  } catch(e) { console.error(e); }
})();

})();
